import { IApiService } from '../../../services/ApiService';
import { LoaderFunctionArgs } from 'react-router';
import { handleLoaderError } from '../../../services/loaderErrorHandler';
import { Logger } from '../../../utils/Logger';

export function programmesPageLoader(apiService: IApiService) {
  return async ({ params, request }: LoaderFunctionArgs) => {
    Logger.debug('LOADER', "programmes loader starting with params:", params);
    try {
      if (!params.bailleurId) {
        throw new Error("Invalid id");
      }
      const bailleurId = parseInt(params.bailleurId, 10);
      if (Number.isNaN(bailleurId)) {
        throw new Error("Invalid id");
      }
      const programmes = await apiService.getProgrammes(bailleurId, request.signal);
      Logger.debug('LOADER', "programmes loader completed with", programmes.length, "programmes");
      return { programmes };
    } catch (error) {
      return handleLoaderError(error, request.url);
    }
  };
}
